import styled, { css } from 'styled-components';

export const DropdownWrapper = styled.div`
    ${({ theme: { boxShadow, palette } }) => css`
        background: ${palette.neutral.white};
        box-shadow: ${boxShadow.big};
        padding: 24px 0 0;
        position: absolute;
        right: -24px;
        top: calc(100% + 8px);
    `}
`;
